<template>
	<div id="app">

		<div class="header_mobile" v-if="isMobile">
			<div class="fl" @click="handleLogoClick">
				<div class="item">
					<img src="./assets/logo.png" />
				</div>
				<div class="item">
					<img src="./assets/mingcheng.png" />
				</div>
			</div>
			<div class="fr" v-if="isAdmin">
				<div class="close_ic" @click="wap_show = !wap_show">
					<van-icon name="wap-nav" v-if="!wap_show" />
					<van-icon name="cross" v-if="wap_show" />
				</div>
			</div>
			<div class="fr" v-if="!isAdmin">
				<div class="mobile_kefu_btn" @click="addToBookmark">
					<van-icon name="star" />
				</div>
				<div class="mobile_kefu_btn" @click="openPublishTip">
					发布账号
				</div>
				<div class="mobile_kefu_btn" @click="openKefu">
					投诉建议
				</div>
			</div>
			<div class="app_menu" v-if="wap_show && isAdmin" @click="wap_show = !wap_show">
				<!-- <div class="item" @click="$router.push('/sell'); wap_show = false">
					<p>发布账号</p>
				</div> -->
				<div class="item" @click="$router.push('/user'); wap_show = false">
					<p>用户中心</p>
				</div>
				<div class="item" v-for="(item, index) in navlist">
					<router-link :to="{ path: item.path }">
						<p>{{ item.name }}</p>
					</router-link>
				</div>
				<div class="item" @click="openKefu">
					<p>投诉建议</p>
				</div>
			</div>
		</div>
		<!-- 用户登录信息栏 -->
		<div class="top-header" v-if="!isMobile">
			<div class="inter">
				<el-row>
					<div class="header">

						<div class="header-left"><a @click="$router.push('/')" class="secondary">
        <span v-if="!login">您好，欢迎访问 - !</span>
        <span v-else-if="isAdmin">欢迎登录，管理员！</span>
        <span v-else>您好，{{ userinfo.nickname }}</span>
    </a></div>
<div class="header-right" >

    <!-- <div class="header-item" v-if="!login"><a @click="openLogin(0)" class="" rel="nofollow"
        title="登录">登录</a>
    </div> -->
    <div class="header-item" v-if="login"><a @click="$router.push('/user')" class="" rel="nofollow"
        title="个人中心">
        <span v-if="isAdmin">管理员：{{ userinfo.nickname }}</span>
        <span v-else>{{ userinfo.nickname }}</span>
    </a></div>
				<div class="header-item" v-if="login"><a @click="logout" class="" rel="nofollow"
					title="退出">退出</a>
				</div>


				<div class="header-item" style="display: none;"><a @click="$router.push('/business')" class="" rel="nofollow" title="帮助中心">帮助中心</a>
				</div>
				<div class="header-item" style="display: none;"><a @click="$router.push('/about')" class="" rel="nofollow" title="关于我们">关于我们</a>
				</div>
				<div class="header-item" style="display: none;"><a @click="openKefu" class="" rel="nofollow" title="联系客服">联系客服</a>
				</div>
				<div class="header-item" style="display: none;"><a @click="addToBookmark" class="" rel="nofollow" title="收藏本站">收藏本站</a>
				</div>
			</div>
					</div>

				</el-row>
			</div>
		</div>
		<el-container v-if="!isMobile" style="display: flex; justify-content: center;">

			<div class="header-wrapper" style="justify-content: flex-end;">
				<div class="logo-area" style="display: none;">
					<a href="." @click.prevent="handleLogoClick">
						<img src="./assets/lianminglogo.png" class="logo-img" />
					</a>
				</div>
				<div class="nav_top" style="justify-content: flex-end;">
								<ul class="nav_list">
									<li v-for="(item, index) in navlist" :key="index" v-if="item.name != '已删除账号' && item.name != '已下架账号' && item.name != '客服配置' && item.name != '发布账号' && !(item.name === '我的商品' && !isAdmin) && !(item.name === '订单管理' && !isAdmin)">
								<router-link :to="{ path: item.path }" @click.native="handleResourceNavClick($event, item)" :active-class="'active'">
									<p>{{ item.name }}</p>
								</router-link>
							</li>
							<li v-for="(item, index) in navlist" :key="index" v-if="item.name == '已删除账号' && isAdmin && login">
								<router-link :to="{ path: item.path }" :active-class="'active'">
									<p>{{ item.name }}</p>
								</router-link>
							</li>
							<li v-for="(item, index) in navlist" :key="index" v-if="item.name == '已下架账号' && isAdmin && login">
								<router-link :to="{ path: item.path }" :active-class="'active'">
									<p>{{ item.name }}</p>
								</router-link>
							</li>
							<li v-for="(item, index) in navlist" :key="index" v-if="item.name == '客服配置' && isAdmin && login">
								<router-link :to="{ path: item.path }" :active-class="'active'">
									<p>{{ item.name }}</p>
								</router-link>
							</li>
							<li v-if="isAdmin && login">
								<router-link to="/adminManage" :active-class="'active'">
									<p>创建/修改客服</p>
								</router-link>
							</li>
							<li v-if="isAdmin && login">
								<router-link to="/adminStats" :active-class="'active'">
									<p>出号统计</p>
								</router-link>
							</li>

									<div class="lianxi_kefu publish-btn" @click="openPublishTip" v-if="!isAdmin" style="display: none;">
										发布账号
									</div>
									<div class="lianxi_kefu" @click="openKefu" v-if="!isAdmin" style="display: none;">
										投诉建议
									</div>

								</ul>
							</div>

						</div>
		</el-container>


		<!-- <router-view :key="this.$route.path"></router-view> -->
		<router-view ref="view" class="bg home_content" />



		<div class="footer" v-if="!isMobileOnDetail">
			<div class="inter">

				<div class="div1">
					<div class="fl" @click="openKefu">
						<div class="wp1">官方在线客服</div>
						<div class="p2">在线客服</div>
						<div class="p3">周一至周日0:00-23:59</div>
					</div>
					<div class="con" style="display: none;">
						<div class="wp1">快速链接</div>
						<div class="footer_link">
							<router-link :to="{ path: '/' }">
								<p>网站首页</p>
							</router-link>

							<router-link :to="{ path: '/about' }">
								<p>关于我们</p>
							</router-link>
							<router-link :to="{ path: '/business' }">
								<p>帮助中心</p>
							</router-link>

						</div>
					</div>
					<!-- <div class="fr">
						<div class="wp1" @click="openKefu">官方在线客服</div>
						<div class="code_img">
							<div class="image">

							</div>
						</div>
					</div> -->
				</div>
				<div class="div2">
					2026 - .All rights reserved.
					<div class="icp-info">
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">鄂ICP备2025150633号</a>
						<span>-</span>
						<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">鄂ICP备2025150633号-5</a>
					</div>
				</div>
			</div>
		</div>



		<el-backtop :visibility-height="0" :right="10" :bottom="80">

		</el-backtop>
		<sell ref="sell" />
		<login ref="login" />


		<el-dialog ref="kefu" :visible.sync="visible_kefu" :center="true" title="添加以下客服投诉" width="600px" destroy-on-close
			@closed="visible_kefu = false">
			<div class="compensationModel_box" style="text-align: center; padding: 20px;">
				<p style="font-size: 16px; color: #333; margin-bottom: 20px;">请添加客服微信进行投诉</p>
				<p style="font-size: 24px; color: #1f9535; font-weight: bold; margin-bottom: 15px;">bbzsh6666</p>
				<p style="font-size: 14px; color: #666;">复制上方微信号，添加客服微信进行问题反馈</p>
				<p style="font-size: 12px; color: #999; margin-top: 20px;">工作时间为：0:00-23:59</p>
			</div>
		</el-dialog>

	</div>
</template>
<script>
import sell from '@/components/dialogs/sell'
import login from '@/components/dialogs/login'
export default {
	components: {
		sell,
		login
	},
	data() {
		return {

			sContent: "This is hello components",

			options: [],
			options2: [{
				value: '0',
				label: '暂无数据',
				disabled: true,
			}],
			options3: [{
				value: '0',
				label: '暂无数据',
				disabled: true,
			}],
			value: "",
			value2: '',
			value3: '',
			key: '',
			site: [],
			navlist: [{
						path: '/',
						name: '资源号出租',
						isSpecial: true
					},
					{
						path: '/sell',
						name: '发布账号'
					},
					{
						path: '/deletedAccounts',
						name: '已删除账号'
					},
					{
						path: '/suspendedAccounts',
						name: '已下架账号'
					},
					{
						path: '/kefuConfig',
						name: '客服配置'
					},
					
				],

			


			topheader: 0,
			winWidth: 1920,
			winHeight: 0,
			hot_index: 0,
			api_kefu: {},
			visible_kefu: false,
			wap_show: false,
			resourceNavClickCount: 0


		}
	},
	computed: {


			login() {
				return this.$store.getters.login
			},
			open_login() {
				return this.$store.getters.open_login
			},

			isMobile() {
				return this.$store.getters.isMobile
			},
			gamelist() {
				return this.$store.getters.gamelist
			},
			allGameList() {
				return this.$store.getters.allGameList
			},
			config() {
				return this.$store.getters.config
			},
			userinfo() {
				return this.$store.getters.userinfo
			},
			isAdmin() {
				return this.$store.getters.isAdmin
			},
			isMobileOnDetail() {
				return this.isMobile && this.$route.path.includes('goodsdetail')
			}
		},
	watch: {
		open_login(v) {
			if (v) {
				this.$refs['login'].visible = true
			}
		},
		winWidth: {
			handler(v) {
				this.$store.commit('SET_IS_MOBILE', v <= 762 ? true : false)
				var route = this.$route
				if (v <= 762) {
					this.$store.commit('SET_IS_MOBILE', true)
					// if (route.name == 'goodsdetail') {
					// 	location.href = "https://wap.yihaods.com/#/pages/index/detail?id=" + route.query.id
					// } else if (route.name == 'goodsdetail2') {
					// 	var str = route.params.id;
					// 	var newStr = str.replace(/\.html$/, '');
					// 	location.href = "https://wap.yihaods.com/#/pages/index/detail?id=" + newStr
					// }  else {
					// 	location.href = "https://wap.yihaods.com"
					// }
				} else {
					this.$store.commit('SET_IS_MOBILE', false)
				}
			},
			immediate: true,
		},

	},
	activated() {

	},
	created: function () {


		this.$store.dispatch('getgameGameList')

		this.$store.dispatch('getCenterConfig')

		this.token()
		var that = this;
		setTimeout(function () {

			if (that.$route.query.topheader != undefined && that.$route.query.topheader != "") {
				that.$data.topheader = that.$route.query.topheader;
			}



			setTimeout(function () {
				if (that.$route.query.keyword != undefined && that.$route.query.keyword != "") {
					that.$data.key = that.$route.query.keyword;
				}
			}, 100);

		}, 500);

		this.getWinWidth()
		this.getWinHeight()

		window.onresize = () => {
			return (() => {
				this.getWinWidth()
				this.getWinHeight()

			})()
		}
	},
	methods: {
		logout(){
			localStorage.removeItem('usertoken')
            sessionStorage.removeItem('usertoken')
            this.$store.commit('SET_userinfo', {})
            this.$store.commit('SET_login', false)
            this.$router.push("/")
			location.reload()
		},
		openKefu() {
			this.visible_kefu = true
		},
		addToBookmark() {
			this.$alert(
				'<div style="text-align: center; padding: 10px 0;">' +
				'<div style="width: 60px; height: 60px; margin: 0 auto 20px; background: linear-gradient(135deg, #e6f7ff 0%, #91d5ff 100%); border-radius: 50%; display: flex; align-items: center; justify-content: center;">' +
				'<i class="el-icon-star-on" style="font-size: 32px; color: #1890ff;"></i></div>' +
				'<p style="font-size: 18px; color: #303133; font-weight: bold; margin-bottom: 10px;">收藏本站</p>' +
				'<p style="font-size: 14px; color: #606266; margin-bottom: 15px; line-height: 1.6;">请点击浏览器地址栏旁边的星标图标<br>或浏览器菜单中的收藏按钮<br>手动添加到收藏夹</p>' +
				'</div>',
				'收藏本站',
				{
					confirmButtonText: '知道了',
					dangerouslyUseHTMLString: true
				}
			);
		},
		openPublishTip() {
			this.$alert(
				'<div style="text-align: center; padding: 10px 0;">' +
				'<div style="width: 60px; height: 60px; margin: 0 auto 20px; background: linear-gradient(135deg, #fdf6ec 0%, #f5dab1 100%); border-radius: 50%; display: flex; align-items: center; justify-content: center;">' +
				'<i class="el-icon-warning" style="font-size: 32px; color: #e6a23c;"></i></div>' +
				'<p style="font-size: 18px; color: #303133; font-weight: bold; margin-bottom: 10px;">暂不支持自主发布</p>' +
				'<p style="font-size: 14px; color: #606266; margin-bottom: 25px; line-height: 1.6;">平台账号由商家入驻发布<br>如需发布账号，请联系客服办理</p>' +
				'<div style="background: #f5f7fa; border-radius: 12px; padding: 20px; display: inline-block;">' +
				'<p style="font-size: 13px; color: #909399; margin-bottom: 12px;">扫码添加客服微信</p>' +
				'<img src="' + require('./assets/客服.png') + '" style="width: 180px; height: 180px; border-radius: 8px; border: 2px solid #fff; box-shadow: 0 2px 12px rgba(0,0,0,0.1);" />' +
				'</div></div>', 
				'发布账号', {
				confirmButtonText: '我知道了',
				customClass: 'publish-tip-dialog',
				dangerouslyUseHTMLString: true
			});
		},
		openLogin(index) {
			this.$refs['login'].active = index
			this.$refs['login'].visible = true
		},
		handleResourceNavClick(event, item) {
			if (item && item.isSpecial) {
				if (!this.login) {
					this.resourceNavClickCount++
					if (this.resourceNavClickCount >= 3) {
						this.resourceNavClickCount = 0
						event.preventDefault()
						this.openLogin(0)
						return false
					}
				}
			}
		},
		handleLogoClick() {
			this.$router.push('/')
		},
		fanhui() {
			// this.$scrollTo('.element-to-scroll-to', 500, { offset: -50 });
		},
		openMai() {
			this.$refs['sell'].visible = true
		},
		getWinWidth() {
			window.width = document.body.clientWidth
			this.winWidth = window.width

		},
		getWinHeight() {
			window.height = document.body.clientHeight
			this.winHeight = window.height
		},
		getSite() {
			this.rq.requests.post("/api/Hall/getSite", {}).then(res => {
				this.$data.site = res.data;

			}).catch(error => {

			})
		},
		token() {
			var that = this
			this.rq.requests.post("api/game/hall/Token", {
				token: localStorage.getItem('usertoken')
			}).then(res => {

				localStorage.setItem('usertoken', res.data.userinfo.token)
				localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo))
				that.$store.commit('SET_userinfo', res.data.userinfo)
				that.$store.commit('SET_login', true)
			}).catch(error => {
				localStorage.removeItem('usertoken')
				localStorage.removeItem('userinfo')
				sessionStorage.removeItem('usertoken')
			})
		},

		gamechange(id) {

			// this.getDaqu(this.$data.value);
			this.$data.value2 = '';
			this.$data.value3 = '';
		},
		daquchange() {

			this.getFuwuqi(this.$data.value2);
			this.$data.value3 = '';
		},

		serch() {



			if (this.$data.value != "") {
				this.$router.push({
					path: '/game?gtype=' + this.$data.value + "&keyword=" + this.$data.key
				})
			}

		}

	}
}
</script>